export default {
    MOBILE_QUERY_767 : 767,
    TABLET_QUERY_768 : 768,
    DESCKTOP_QUERY_1366: 1366,
};
